import React from 'react'
import Education from '../../components/education/education'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/footer'
import { Helmet } from 'react-helmet'
export default function EducationPage() {
  return (
    <div>
      <Helmet>
            <title>Education — Gopal Goyal | IIT Bombay</title>
            <meta name='description'
            content='Education of Gopal Goyal — MSc in Physics from IIT Bombay (CGPA 7.56) and BSc in Physics from University of Rajasthan.'/>
            <meta name='keywords' content='Gopal Goyal education, IIT Bombay, MSc Physics, University of Rajasthan'/>
        </Helmet>
      <Header/>
      <Education/>
      <Footer/>
    </div>
  )
}
